import { render, staticRenderFns } from "./AppointDetail.vue?vue&type=template&id=dfa1a064&scoped=true&"
import script from "./AppointDetail.vue?vue&type=script&lang=js&"
export * from "./AppointDetail.vue?vue&type=script&lang=js&"
import style0 from "./AppointDetail.vue?vue&type=style&index=0&id=dfa1a064&lang=less&scoped=true&"
import style1 from "./AppointDetail.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfa1a064",
  null
  
)

export default component.exports